import React from "react";
import { Table, TableBody, TableContainer, TableHead } from "@mui/material";
import TablePageButtons from "./TablePageButtons";

const EntityListTable = ({
  currentPage,
  hasNextPage,
  onPageButtonClicked,
  tableHeaderComponent,
  children,
}) => {

  return (
    <>
      <TableContainer>
        <Table size="small" aria-label="user table">
          <TableHead>
            {tableHeaderComponent}
          </TableHead>
          <TableBody>
            {children}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePageButtons
        currentPage={currentPage}
        hasNextPage={hasNextPage}
        onPageButtonClicked={onPageButtonClicked}
      />
    </>
  );
};

export default EntityListTable;
